<div class="icon-menu-rail">
  @if (isPosShell()) {
    <div class="icon-menu-rail__top icon-menu-rail__top--solo">
      <div class="icon-menu-rail__brand">
        <app-branding class="rail-branding" variant="isotype" [navigable]="false"></app-branding>
      </div>
    </div>
  } @else {
    <!-- Compacta: isotipo centrado; flecha al lado (canal derecho). Completa: logo + ← en el panel. -->
    @if (collapsed) {
      <div class="icon-menu-rail__top" [class.icon-menu-rail__top--solo]="!showExpandToggle">
        <div class="icon-menu-rail__brand">
          <app-branding class="rail-branding" variant="isotype"></app-branding>
        </div>
        @if (showExpandToggle) {
          <button
            type="button"
            class="icon-menu-rail__expand"
            (click)="toggleCollapsed.emit(); $event.stopPropagation()"
            [attr.aria-label]="'layout.expandSidebar' | translate"
            [attr.title]="'layout.expandSidebar' | translate"
          >
            <span
              class="iconify"
              data-icon="solar:alt-arrow-right-linear"
              aria-hidden="true"
            ></span>
          </button>
        }
      </div>
    }
  }

  <mat-nav-list class="text-center sidebar-tooltip icon-menu-rail__primary">
    @for (item of getFlattenedItems(menuItems); track item.id) {
      <mat-list-item
        cdkOverlayOrigin
        #itemOrigin="cdkOverlayOrigin"
        [class.is-active]="item.id === selectedMenu"
        class="menu-list-item icon-menu-item p-0!"
        (click)="selectIcon(item.id)"
        (mouseenter)="onRailItemEnter(itemOrigin, item.id)"
        (mouseleave)="onRailItemLeave()"
      >
        <div class="icon-menu-item__content">
          <span class="icon-menu-item__icon-wrap">
            <app-nav-icon-pair
              [icon]="item.iconName"
              [active]="item.id === selectedMenu"
              iconClass="icon-menu-item__icon"
            />
            @if (item.planLocked) {
              <span class="icon-menu-item__plan-dot" aria-hidden="true"></span>
            }
            @if (item.id === pedidosRailId && hubPendingCount() > 0) {
              <span class="icon-menu-item__count-badge" aria-hidden="true">{{
                hubPendingCount() > 99 ? '99+' : hubPendingCount()
              }}</span>
            }
          </span>
          <span class="icon-menu-item__label">{{ item.title | translate }}</span>
        </div>
      </mat-list-item>
    }

    @if (showContextSwitch()) {
      <mat-list-item
        class="menu-list-item icon-menu-item icon-menu-item--context p-0! mt-1"
        (click)="onContextSwitch()"
      >
        <div class="icon-menu-item__content">
          <span class="icon-menu-item__icon-wrap icon-menu-item__icon-wrap--accent">
            <span class="iconify icon-menu-item__icon" [attr.data-icon]="contextSwitchIcon()"></span>
          </span>
          <span class="icon-menu-item__label">{{ contextSwitchLabelKey() | translate }}</span>
        </div>
      </mat-list-item>
    }
  </mat-nav-list>
</div>

@if (flyoutOrigin) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="flyoutOrigin"
    [cdkConnectedOverlayOpen]="flyoutOpen"
    [cdkConnectedOverlayPositions]="flyoutPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="12"
    (overlayOutsideClick)="closeFlyoutFromOutside()"
  >
    <div
      class="rail-module-flyout"
      role="menu"
      (mouseenter)="onFlyoutEnter()"
      (mouseleave)="onFlyoutLeave()"
    >
      <span class="rail-module-flyout__caret" aria-hidden="true"></span>
      <div class="rail-module-flyout__body">
        @for (child of flyoutChildren; track trackFlyoutChild(child, $index)) {
          @if (child.navCap) {
            <div
              class="rail-module-flyout__cap"
              [class.rail-module-flyout__cap--brand]="child.navCapBrand"
              [class.rail-module-flyout__cap--divider]="child.divider"
            >
              {{ child.navCap }}
            </div>
          } @else if (child.route) {
            <a
              class="rail-module-flyout__link"
              role="menuitem"
              href="#"
              [class.is-active]="isRouteActive(child.route)"
              [class.is-disabled]="child.disabled"
              (click)="onFlyoutLinkClick($event, child)"
            >
              @if (child.iconName) {
                <app-nav-icon-pair
                  class="rail-module-flyout__icon"
                  [icon]="child.iconName"
                  [active]="isRouteActive(child.route)"
                  iconClass="rail-module-flyout__icon"
                />
              }
              <span class="rail-module-flyout__text">{{ child.displayName | translate }}</span>
              @if ((child.route === '/pos/pedidos' || child.route === '/sales/pos/pedidos') && hubPendingCount() > 0) {
                <span class="rail-module-flyout__count">{{
                  hubPendingCount() > 99 ? '99+' : hubPendingCount()
                }}</span>
              }
              @if (child.planLocked) {
                <span class="rail-module-flyout__plan">Plan</span>
              }
            </a>
          }
        }
      </div>
    </div>
  </ng-template>
}
